module.exports = __webpack_public_path__ + "static/img8-42d5a525683b8d110d77a0b2fa2167df.png";